import { Close as IconDeleteOption } from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Shared_FormTemplate_QuestionFragment } from "~/shared/components/FormTemplate/fragments/fragments.generated";

import QuestionConditionIsEqualFields from "./QuestionConditionIsEqualFields";

type Props = {
    selectableConditionQuestions: Shared_FormTemplate_QuestionFragment[];
};

export default function QuestionConditionOrFields({ selectableConditionQuestions }: Props) {
    const { t } = useTranslation("formTemplateEditor");

    const { control } = useFormContext();
    const { fields, append, remove } = useFieldArray({
        control,
        name: "conditionOrConditions",
    });

    const canDelete = fields.length >= 3;

    return (
        <Stack rowGap={2} direction="column" justifyContent="flex-start">
            {fields.map((field, index) => (
                <Stack key={field.id} direction="row" justifyContent="flex-start" alignItems="baseline">
                    <QuestionConditionIsEqualFields
                        selectableConditionQuestions={selectableConditionQuestions}
                        namePrefix={`conditionOrConditions.${index}.`}
                    />
                    {canDelete && (
                        <IconButton onClick={() => remove(index)}>
                            <IconDeleteOption fontSize="small" />
                        </IconButton>
                    )}
                </Stack>
            ))}
            <Button onClick={() => append({ id: crypto.randomUUID() })} size="small" variant="text">
                {t("formTemplateQuestionForm.btnAddCondition")}
            </Button>
        </Stack>
    );
}
